import React, { useCallback, useEffect, useState } from "react";
import "./../Form.scss";
import "./PedidosForm.scss";
import { useHistory, useParams } from "react-router";
import service from "../../../services/pedidos";
import serviceCatalogos from "../../../services/catalogos";
import serviceProdutos from "../../../services/produtos";
import serviceUsuarios from "../../../services/usuarios";
import serviceCampanhas from "../../../services/campanhas";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faSave, faTimes, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { hasText, isDate, maskDate } from "../../../utils/utils";
import { actions as actionsSite } from "../../../redux/actions/site";
import { useDispatch, useSelector } from "react-redux";
import { date2Front, datetime2Front } from "../../../utils/converts";
import { currencyToFloat, formatCurrency } from "../../../utils/Money";
import { getSituacao } from "./Pedidos";

const PedidosForm = (props) => {
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.auth.profile);
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const params = useParams();
  const [produtos, setProdutos] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [usuariosOptions, setUsuariosOptions] = useState([]);
  const [usuariosOptionsIndexSelected, setUsuariosOptionsIndexSelected] = useState(0);
  const [showOptionsUsuarios, setShowOptionsUsuarios] = useState(false);
  const [catalogos, setCatalogos] = useState([]);
  const [itemPedidos, setItemPedidos] = useState([]);
  const [campanhas, setCampanhas] = useState([]);

  const catalogoInicial = "618edaffb1812aa6e681ab46";
  const [pedido, setPedido] = useState({ catalogo: catalogoInicial });

  const { register, handleSubmit, setValue, errors, getValues, setError } = useForm();

  const rota = props.compra ? "pedidos-compra" : "pedidos-venda";

  const onSubmit = (data) => {
    data.usuario = pedido.usuario;

    if (props.compra) {
      data["usuario"] = profile._id;
      data["tipo"] = "Compra";
    } else {
      data["tipo"] = "Venda";
    }
    data["itemPedidos"] = itemPedidos;

    save(data);
  };

  const carregarPedido = useCallback(async (id) => {
    const pedidoInicial = await service.getById(id);
    setPedido(pedidoInicial);
    setItemPedidos(pedidoInicial.items);
    setLoading(false);
  }, []);

  useEffect(() => {
    //pedido.catalogo = catalogoInicial; //Alteração realizada para que a getInfoProduct() reconheça o catalogo inicial logo na primeira execução
    const run = async () => {
      const _catalogos = serviceCatalogos.get(`?catalogo=NULL&sort=nome&active=true`);
      const _produtos = serviceProdutos.get(`?active=true`);
      const _usuarios = serviceUsuarios.get(`?active=true&sort=nome`);
      const _campanhas = serviceCampanhas.get(`?active=true&sort=dataInicio`);
      const [_resCatalogos, _resProdutos, _resUsuarios, _resCampanhas] = await Promise.all([_catalogos, _produtos, _usuarios, _campanhas]);
      if (props.compra) {
        _resProdutos.rows = _resProdutos.rows.map((produto) => {
          produto.valor -= (produto.valor * 30) / 100;
          return produto;
        });
      }
      setProdutos(_resProdutos.rows);
      setCatalogos(_resCatalogos.rows);
      setUsuarios(_resUsuarios.rows);
      setCampanhas(_resCampanhas.rows);
      if (params.id) {
        carregarPedido(params.id);
      } else {
        setLoading(false);
      }
    };
    run();
  }, [carregarPedido, params.id]);

  const save = async (data) => {
    dispatch(actionsSite.setModal(null));
    dispatch(actionsSite.setLoadingMsg("Enviando dados..."));
    const res = await service.upsert(data, pedido._id);
    dispatch(actionsSite.setLoadingMsg(res.msg));
    setTimeout(() => {
      dispatch(actionsSite.setLoadingMsg(""));
      if (data.goToProcess && !res.erro) {
        history.push("/painel/" + rota + "/process/" + res._id);
      } else {
        if (!params.id && !res.erro) {
          history.push("/painel/" + rota);
        }
      }
    }, 3000);
  };

  const baseItemPedidoObj = {
    _id: null,
    produto: "",
    quantidade: "1",
    valor: "0,00",
    desconto: "0.00",
    // outros
    codigo: "",
    descricao: "",
    valorTotal: "0",
  };

  const changeCatalogo = (e) => {
    const _pedido = { ...pedido };
    _pedido.catalogo = e.target.value;
    if (_pedido.catalogo == "618edaffb1812aa6e681ab46") {
      itemPedidos.map((e) => {
        e.desconto = "30.00";
      });
    } else {
      itemPedidos.map((e) => {
        e.desconto = "0.00";
      });
    }
    setPedido(_pedido);
  };

  const optionCatalogos = () => {
    const op = [...catalogos];
    op.sort((a,b)=>a.apelido.toUpperCase() > b.apelido.toUpperCase() ? 1 : -1)
    op.unshift({ _id: "", apelido: "Selecione um catálogo" });
    return op.map((o, i) => {
      return (
        <option key={i} value={o._id}>
          {o.apelido.toUpperCase()}
        </option>
      );
    });
  };

  const selecionaUsuario = (usuario) => {
    const clone = { ...pedido };
    clone.usuario = usuario;
    setShowOptionsUsuarios(false);
    setPedido(clone);
  };

  const unsetUsuarioSelecionado = () => {
    const clone = { ...pedido };
    clone.usuario = null;
    setPedido(clone);
  };

  const filterOptionsUsuarios = (e) => {
    const value = e.target.value;
    if (value.length >= 2) {
      const clone = [...usuarios];
      const filtered = clone.filter((usuario) => {
        const test = usuario.nome.toUpperCase().indexOf(value.toUpperCase()) !== -1;
        return test;
      });
      setUsuariosOptionsIndexSelected(0);
      setUsuariosOptions(filtered.slice(0, 10));
      setShowOptionsUsuarios(true);
    } else {
      setUsuariosOptions([]);
      setShowOptionsUsuarios(false);
    }
  };

  const selectOptionsUsuarios = (e) => {
    let nextIndex = 0;
    if (["ArrowUp", "ArrowDown", "Tab"].includes(e.key)) {
      if (["ArrowDown", "Tab"].includes(e.key)) {
        nextIndex = usuariosOptionsIndexSelected + 1;
        if (nextIndex > usuariosOptions.length - 1) {
          nextIndex = 0;
        }
      } else {
        nextIndex = usuariosOptionsIndexSelected - 1;
        if (nextIndex < 0) {
          nextIndex = usuariosOptions.length - 1;
        }
      }
      setUsuariosOptionsIndexSelected(nextIndex);
    }
    if (["Enter"].includes(e.key)) {
      if (showOptionsUsuarios) {
        selecionaUsuario(usuariosOptions[usuariosOptionsIndexSelected]);
        // document.querySelector("#valor").focus();
      }
    }

    if (["Tab"].includes(e.key)) {
      if (showOptionsUsuarios) {
        e.preventDefault();
      }
    }

    if (["Enter"].includes(e.key)) {
      e.preventDefault();
    }
  };

  const changePagamento = (e) => {
    const _pedido = { ...pedido };
    _pedido.tipoPagamento = e.target.value;
    setPedido(_pedido);
  };

  const optionTiposPagamento = () => {
    const op = [
      { _id: "PIX", label: "PIX" },
      { _id: "Débito", label: "Débito" },
      { _id: "Crédito", label: "Crédito" },

      { _id: "Crédito Parcelado", label: "Crédito Parcelado" },
      { _id: "A Prazo - Dinheiro", label: "A Prazo - Dinheiro" },
      { _id: "A Prazo - Boleto", label: "A Prazo - Boleto" },
      { _id: "A Prazo - Campanha", label: "A Prazo - Campanha" },
    ];
    op.unshift({ _id: "", label: "Selecione um Pagamento" });
    return op.map((o, i) => {
      return (
        <option key={i} value={o._id}>
          {o.label}
        </option>
      );
    });
  };

  const renderFormItemPedidos = () => {
    if (itemPedidos.length < 1) {
      addItemPedido();
    }
    return (
      <table cellPadding="0" cellSpacing="0" className="itensPedido">
        <thead>
          <tr>
            <th width="150">Código Produto</th>
            <th width="80">Qtd.</th>
            <th width="80">Tamanho</th>
            <th>Descrição</th>
            <th width="100">Valor Unit.</th>
            {!props.compra && <th width="100">Desc %</th>}
            <th className="total" width="150">
              Valor Total
            </th>
            <th className="acoes" width="100"></th>
          </tr>
        </thead>
        <tbody>
          {itemPedidos.map((e, index) => {
            return (
              <tr key={index}>
                <td>
                  <div className="field">
                    <input
                      name={`codigo${index}`}
                      id={`codigo${index}`}
                      type="text"
                      className={"hasText"}
                      onKeyUp={(e) => hasText(e)}
                      ref={register()}
                      defaultValue={e.produto.codigo}
                      onChange={(event) => {
                        changeValueField(e, "codigo", event.target.value, resetItemPedidos);
                      }}
                      onBlur={(event) => {
                        getInfoProduct(event.target.value, { index, obj: e });
                      }}
                    />
                  </div>
                </td>
                <td>
                  <div className="field">
                    <input
                      name={`quantidade${index}`}
                      id={`quantidade${index}`}
                      type="text"
                      className={"hasText"}
                      onKeyUp={(e) => hasText(e)}
                      ref={register()}
                      value={e.quantidade}
                      onChange={(event) => {
                        changeValueField(e, "quantidade", event.target.value, resetItemPedidos);
                      }}
                    />
                  </div>
                </td>
                <td>
                  <div className="field">
                    <input
                      name={`tamanho${index}`}
                      id={`tamanho${index}`}
                      type="text"
                      className={"hasText"}
                      onKeyUp={(e) => hasText(e)}
                      ref={register()}
                      defaultValue={e.tamanho}
                      onChange={(event) => {
                        changeValueField(e, "tamanho", event.target.value, resetItemPedidos);
                      }}
                    />
                  </div>
                </td>
                <td>
                  <div className="field">
                    <input
                      name={`descricao${index}`}
                      id={`descricao${index}`}
                      type="text"
                      className={"hasText"}
                      onKeyUp={(e) => hasText(e)}
                      ref={register()}
                      defaultValue={e.produto.nome}
                      onChange={(event) => {
                        changeValueField(e, "descricao", event.target.value, resetItemPedidos);
                      }}
                    />
                  </div>
                </td>
                <td>
                  <div className="field">
                    <input
                      name={`valor${index}`}
                      id={`valor${index}`}
                      type="text"
                      className={"hasText"}
                      onKeyUp={(e) => hasText(e)}
                      ref={register()}
                      value={formatCurrency(e.valor)}
                      onChange={(event) => {
                        changeValueMoney(event.target.value, { index, campo: "valor" });
                        changeValueField(e, "valor", currencyToFloat(event.target.value), resetItemPedidos);
                      }}
                    />
                  </div>
                </td>
                {!props.compra && (
                  <td>
                    <div className="field">
                      {/* {formatCurrency(e.desconto)} */}
                      <input
                        name={`desconto${index}`}
                        id={`desconto${index}`}
                        type="text"
                        className={"hasText"}
                        onKeyUp={(e) => hasText(e)}
                        ref={register()}
                        value={formatCurrency(e.desconto)}
                        onChange={(event) => {
                          changeValueMoney(event.target.value, { index, campo: "desconto" });
                          changeValueField(e, "desconto", currencyToFloat(event.target.value), resetItemPedidos);
                        }}
                      />
                    </div>
                  </td>
                )}
                <td>
                  <div className="total">{calculateTotalValue(index)}</div>
                </td>
                <td>
                  <div className="acoes">
                    {buttonAdd(addItemPedido)}
                    {buttonRmv(index, rmvItemPedido)}
                    <input type="hidden" name={`produto${index}`} id={`produto${index}`} defaultValue={e.produto._id} ref={register()} />
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  const changeValueMoney = (value, args) => {
    const campo = args.campo + args.index;
    const newValue = formatCurrency(value);
    setValue(campo, newValue);
    document.querySelector("#" + args.campo + args.index).classList.add("hasText");
  };

  const calculateTotalValue = (index) => {
    const value = itemPedidos[index].valor;
    const desconto = props.compra ? 0 : ((itemPedidos[index].desconto * itemPedidos[index].valor) / 100).toFixed(2);
    const qty = parseInt(itemPedidos[index].quantidade);
    const total = formatCurrency((value - desconto) * qty);
    return total;
  };

  const getInfoProduct = (codigo, args) => {
    const produto = produtos.find((p) => p.codigo.toUpperCase() === codigo.toUpperCase());
    const descricaoField = `descricao${args.index}`;
    const produtoField = `produto${args.index}`;
    const valorField = `valor${args.index}`;
    if (produto && produto.catalogo == pedido.catalogo) {
      const descricaoValue = `${produto.nome} `;
      const { obj, index } = args;
      obj["descricao"] = descricaoValue;
      obj["produto"] = produto._id;
      obj["valor"] = produto.valor;
      setValue(descricaoField, descricaoValue);
      setValue(produtoField, produto._id);
      setValue(valorField, formatCurrency(produto.valor));
      resetItemPedidos();
    } else {
      const descricaoValue = "";
      const { obj } = args;
      obj["descricao"] = descricaoValue;
      obj["produto"] = "";
      obj["valor"] = "0,00";
      setValue(descricaoField, descricaoValue);
      setValue(produtoField, "");
      setValue(valorField, "0,00");
    }
  };

  const addItemPedido = () => {
    const _itemPedidos = [...itemPedidos];
    if (pedido.catalogo == "618edaffb1812aa6e681ab46") {
      baseItemPedidoObj.desconto = "30.00";
    }
    _itemPedidos.push(baseItemPedidoObj);
    setItemPedidos(_itemPedidos);
  };

  const rmvItemPedido = (index) => {
    const _itemPedidos = [...itemPedidos];
    const obj = _itemPedidos[index];
    if (obj._id && obj._id !== "") {
      openModalRemoveItemPedido(index, obj._id);
    } else {
      rmvItemItemPedido(index);
    }
  };

  const rmvItemItemPedido = (index) => {
    const _itemPedidos = [...itemPedidos];
    _itemPedidos.splice(index, 1);
    setItemPedidos(_itemPedidos);
  };

  const removerItemPedido = async (arg) => {
    const { index, id } = arg;
    dispatch(actionsSite.setModal(null));
    // dispatch(actionsSite.setLoadingMsg("Excluindo item..."));
    // const res = await service.excluirItemPedido(id);
    // dispatch(actionsSite.setLoadingMsg(res.msg));
    // setTimeout(() => {
    rmvItemItemPedido(index);
    //     dispatch(actionsSite.setLoadingMsg(""));
    // }, 3000);
  };
  const resetItemPedidos = () => {
    const _itemPedidos = [...itemPedidos];
    setItemPedidos(_itemPedidos);
  };

  const openModalRemoveItemPedido = (index, id) => {
    const configModal = {
      msg: `Tem certeza que deseja excluir esse item?`,
      title: "Excluir item",
      actions: [{ label: "Sim", class: "azul", callback: removerItemPedido, arg: { index, id } }],
    };

    dispatch(actionsSite.setModal(configModal));
  };

  const openModalProcessar = (data) => {
    const configModal = {
      msg: `Deseja processar os itens?`,
      title: "Processar item",
      actions: [
        {
          label: "Somente salvar",
          class: "azul",
          callback: onSubmit,
          arg: data,
        },
        {
          label: "Salvar e processar",
          class: "verde",
          callback: onSubmit,
          arg: { ...data, goToProcess: true },
        },
      ],
    };
    dispatch(actionsSite.setModal(configModal));
  };

  const addBreak = () => {
    return <div className="break"></div>;
  };

  const buttonAdd = (action) => {
    return (
      <div className="field botaoAdd">
        <button type="button" onClick={action}>
          <FontAwesomeIcon icon={faPlus} />
        </button>
      </div>
    );
  };

  const buttonRmv = (index, action) => {
    return (
      <div className="field botaoRmv">
        <button type="button" onClick={() => action(index)}>
          <FontAwesomeIcon icon={faTrash} />
        </button>
      </div>
    );
  };

  const changeValueField = (obj, field, value, cb = null) => {
    obj[field] = value;
    if (cb) {
      cb();
    }
  };

  return (
    <>
      {!loading && (
        <div className="form pedidos">
          <form onSubmit={handleSubmit(openModalProcessar)} className="formModule branco pedidosForm">
            {!params.id && (
              <div className="acoes">
                <button type="submit" className="salvar">
                  <FontAwesomeIcon icon={faSave} /> {params.id ? "Editar" : "Salvar"}
                </button>
                <button type="button" className="cancelar" onClick={() => history.push("/painel/" + rota)}>
                  <FontAwesomeIcon icon={faBan} /> Voltar
                </button>
              </div>
            )}
            {params.id && (
              <div className="acoes">
                <button type="submit" className="salvar">
                  <FontAwesomeIcon icon={faSave} /> {params.id ? "Editar" : "Salvar"}
                </button>
                <button type="button" className="cancelar" onClick={() => history.push("/painel/" + rota)}>
                  <FontAwesomeIcon icon={faBan} /> Voltar
                </button>
              </div>
            )}
            <div className="break mt20"></div>

            {params.id && (
              <>
                <div className="field">
                  <input className={"hasText"} defaultValue={pedido.sequencia} type="text" readOnly />
                  <label>Nº</label>
                </div>
                <div className="field">
                  <input className={"hasText"} defaultValue={getSituacao(pedido)} type="text" readOnly />
                  <label>Situação</label>
                </div>
                {addBreak()}
              </>
            )}

            <div className={errors.catalogo ? "field error" : "field"}>
              <select name="catalogo" className="hasText" ref={register({ required: true })} id="catalogo" value={pedido.catalogo || catalogoInicial} onChange={(e) => changeCatalogo(e)}>
                {optionCatalogos()}
              </select>
              <label htmlFor="catalogo">Catálogo</label>
            </div>
            {!props.compra && (
              <div className={errors.usuario ? "field error" : "field"}>
                {pedido.usuario && (
                  <div className="autocomplete selected">
                    <input className={"hasText"} name="usuario" id="usuario" type="text" readOnly value={pedido.usuario.nome} />
                    <div
                      className="unset"
                      onClick={() => {
                        unsetUsuarioSelecionado();
                      }}
                    >
                      x
                    </div>
                  </div>
                )}
                {!pedido.usuario && (
                  <input
                    className={"hasText"}
                    name="usuario"
                    id="usuario"
                    onKeyUp={(e) => {
                      hasText(e);
                    }}
                    onChange={(e) => {
                      filterOptionsUsuarios(e);
                    }}
                    onKeyDown={(e) => {
                      selectOptionsUsuarios(e);
                    }}
                    onClick={(e) => e.stopPropagation()}
                    ref={register({ required: true })}
                    autoComplete="off"
                    type="text"
                  />
                )}
                <label htmlFor="valor" className="hasText">
                  Revendedora
                </label>
                {showOptionsUsuarios && (
                  <ul id="options" tabIndex="0">
                    {usuariosOptions.map((v, index) => {
                      return (
                        <li key={index} className={index === usuariosOptionsIndexSelected ? "selected" : ""} onClick={() => selecionaUsuario(v)}>
                          {v.nome}
                        </li>
                      );
                    })}
                  </ul>
                )}
              </div>
            )}

            {props.compra && (
              <>
                <div className={errors.tipoPagamento ? "field error" : "field"}>
                  <select name="tipoPagamento" className="hasText" ref={register({ required: true })} id="tipoPagamento" value={pedido.tipoPagamento || ""} onChange={(e) => changePagamento(e)}>
                    {optionTiposPagamento()}
                  </select>
                  <label htmlFor="tipoPagamento">Pagamento</label>
                </div>

                <div className={errors.numeroNf ? "field error" : "field"}>
                  <input
                    className={pedido.numeroNf ? "hasText" : ""}
                    name="numeroNf"
                    id="numeroNf"
                    defaultValue={pedido.numeroNf}
                    onKeyUp={(e) => hasText(e)}
                    type="text"
                    ref={register({ required: true })}
                    readOnly={params.id}
                  />
                  <label htmlFor="numeroNf">NF</label>
                </div>

                <div className={errors.numeroParcelas ? "field error" : "field"}>
                  <input
                    className={pedido.numeroParcelas ? "hasText" : ""}
                    name="numeroParcelas"
                    id="numeroParcelas"
                    defaultValue={pedido.numeroParcelas}
                    onKeyUp={(e) => hasText(e)}
                    type="text"
                    ref={register({ required: true, validate: { isNumeric: (value) => !isNaN(value) } })}
                    readOnly={params.id}
                  />
                  <label htmlFor="numeroParcelas">Parcelas</label>
                </div>

                <div className={errors.dataEntrega ? "field error" : "field"}>
                  <input
                    name="dataEntrega"
                    id="dataEntrega"
                    maxLength={10}
                    type="text"
                    className={pedido.dataEntrega && pedido.dataEntrega !== "" ? "hasText" : ""}
                    onKeyUp={(e) => {
                      maskDate(e);
                      hasText(e);
                    }}
                    ref={register({ validate: { isDate: (value) => isDate(value) } })}
                    defaultValue={date2Front(pedido.dataEntrega)}
                    readOnly={params.id}
                  />
                  <label htmlFor="dataEntrega">Data da entrega</label>
                </div>

                <div className="break"></div>
                <div className={errors.obs ? "field error" : "field"}>
                  <input className={pedido.obs ? "hasText" : ""} name="obs" id="obs" defaultValue={pedido.obs} onKeyUp={(e) => hasText(e)} type="text" ref={register()} readOnly={params.id} />
                  <label htmlFor="obs">Observações</label>
                </div>
              </>
            )}

            {!props.compra && params.id && (
              <>
                <div className={errors.createAt ? "field error" : "field"}>
                  <input name="createAt" id="createAt" type="text" className={"hasText"} defaultValue={datetime2Front(pedido.createAt)} readOnly={params.id} />
                  <label htmlFor="createAt">Data</label>
                </div>
              </>
            )}

            <div className="break"></div>
            <h3 className="tituloEtapa mt20">Itens</h3>
            <div className="break"></div>
            {renderFormItemPedidos()}

            <div className="break mt20"></div>
            {!params.id && (
              <div className="acoes">
                <button type="submit" className="salvar">
                  <FontAwesomeIcon icon={faSave} /> {params.id ? "Editar" : "Salvar"}
                </button>
                <button type="button" className="cancelar" onClick={() => history.push("/painel/" + rota)}>
                  <FontAwesomeIcon icon={faBan} /> Voltar
                </button>
              </div>
            )}
            {params.id && (
              <div className="acoes">
                <button type="submit" className="salvar">
                  <FontAwesomeIcon icon={faSave} /> {params.id ? "Editar" : "Salvar"}
                </button>
                <button type="button" className="cancelar" onClick={() => history.push("/painel/" + rota)}>
                  <FontAwesomeIcon icon={faBan} /> Voltar
                </button>
              </div>
            )}
          </form>
          {errors && Object.keys(errors).length > 0 && (
            <div className="erros">
              <div>
                <FontAwesomeIcon icon={faTimes} /> Existem erros no formulário
              </div>
            </div>
          )}
        </div>
      )}
      {loading && "Carregando..."}
    </>
  );
};

export default PedidosForm;
